.spinner {
  display: inline-block;
  border-radius: var(--radius-circle);
  border-style: solid;
  /* 3 sides of the border are 15%-opacity version of currentColor (so the
   * "track" is visible against any background), the 4th side is the full
   * currentColor acting as the rotating head. Using border-top-color means
   * the head starts at 12 o'clock. */
  border-color: color-mix(in srgb, currentColor 15%, transparent);
  border-top-color: currentColor;
  animation: spinner-rotate 0.8s linear infinite;
  box-sizing: border-box;
  flex-shrink: 0;
}

/* sizes match Icon so <Button loading leadingIcon>... renders cleanly */
.size-xs { width: 14px; height: 14px; border-width: 2px; }
.size-sm { width: 16px; height: 16px; border-width: 2px; }
.size-md { width: 20px; height: 20px; border-width: 2px; }
.size-lg { width: 24px; height: 24px; border-width: 3px; }

/* tone */
.tone-brand   { color: var(--brand); }
.tone-inherit { color: inherit; }

@keyframes spinner-rotate {
  to { transform: rotate(360deg); }
}

/* respect user's motion preference — per WCAG 2.3.3 and the vestibular
 * disorder guidance, stop rotation entirely rather than just slowing it.
 * The static visual remains meaningful: the border has one bright quarter
 * (border-top: currentColor) against three faint quarters (15% alpha),
 * which reads as "partial ring" / "in progress" even without motion.
 * The role="status" + aria-label="Loading" on the <span> is the primary
 * accessibility signal regardless. */
@media (prefers-reduced-motion: reduce) {
  .spinner {
    animation: none;
  }
}
